import React from "react";
import RdvTypes from "./RdvTypes";
import RdvTemplates from "./RdvTemplates";
import Week from "./Week";
import SpecialDays from "./SpecialDays";
import Others from "./Others";

class OptionsTabs extends React.Component {
  state = {
    tab: 0
  };

  renderOpenTab = () => {
    const userId = this.props.doctorId;
    switch (this.state.tab) {
      case 0:
        return <RdvTypes doctorId={userId} />;
      case 1:
        return <RdvTemplates doctorId={userId} />;
      case 2:
        return <Week doctorId={userId} />;
      case 3:
        return <SpecialDays doctorId={userId} />;
      case 4:
        return <Others doctorId={userId} />;
      default:
        return <RdvTypes doctorId={userId} />;
    }
  };
  changeTab = i => {
    this.setState({ tab: i });
  };

  render() {
    if (this.props.role === "SECRETARY") {
      this.props.history.replace("/");
    }
    return (
      <React.Fragment>
        <div className="tabs is-centered">
          <ul>
            <li className={this.state.tab === 0 ? "is-active" : ""}>
              <a onClick={i => this.changeTab(0)}>
                <span>RDV Types</span>
              </a>
            </li>
            <li className={this.state.tab === 1 ? "is-active" : ""}>
              <a onClick={i => this.changeTab(1)}>
                <span>Templates</span>
              </a>
            </li>
            <li className={this.state.tab === 2 ? "is-active" : ""}>
              <a onClick={i => this.changeTab(2)}>
                <span>Ma Semaine</span>
              </a>
            </li>
            <li className={this.state.tab === 3 ? "is-active" : ""}>
              <a onClick={i => this.changeTab(3)}>
                <span>Special Days</span>
              </a>
            </li>
            <li className={this.state.tab === 4 ? "is-active" : ""}>
              <a onClick={i => this.changeTab(4)}>
                <span>Autres</span>
              </a>
            </li>
          </ul>
        </div>
        <div className="open">{this.renderOpenTab()}</div>
      </React.Fragment>
    );
  }
}

export default OptionsTabs;



// WEBPACK FOOTER //
// ./src/components/OptionsTabs.js